import { Helmet } from "react-helmet-async";
import { useGetFrontendMetadata } from "../hooks/useSettings";

export interface MetadataProps {

}
const Metadata: React.FC<MetadataProps> = ({

}) => {

  const { data: frontendMetadata = null } = useGetFrontendMetadata();
  let title = ""
  let favicon = ""
  if (frontendMetadata) {
    title = frontendMetadata?.title || "Federfarma"
    favicon = frontendMetadata?.favicon || "./favicon.ico"
  }


  return (
    <Helmet>
      <title>{title}</title>
      <link rel="icon" type="icon" href={favicon} />
    </Helmet>
  );
};

export default Metadata;
